import React from 'react'

export default class AutoCompleteAddressInput extends React.Component {
    clearButtonStyle() {
        return Object.assign({}, styles.clearButton, {visibility: ((this.props.value.length > 0) ? 'visible' : 'hidden')});
    }

    render() {
        return (
            <div>
                <input style={styles.searchInput}
                       type="text"
                       disabled={this.props.disabled}
                       value={this.props.disabled ? 'Attendi...' : this.props.value}
                       placeholder="Inserisci un indirizzo o muovi la mappa"
                       onChange={(event) => this.props.onChange(event.target.value)}
                />
                {/*<span className="fa fa-times"
                      style={ this.clearButtonStyle() }
                      onClick={() => this.props.onChange('')}/> */}
            </div>
        )
    }
}

const styles = {
    clearButton: {
        position: 'absolute',
        right: '10px',
        paddingTop: '10px',
        color: 'gray',
        fontSize: '20px',
        cursor: 'pointer'
    },

    searchInput: {
        width: '100%',
        height: '44px',
        padding: '10px',
        fontSize: '16px'
    }
};